<template>
  <div id="AppLogin">
    <header class="nav background" style="border-bottom: 1px;display: flex;">
    <div class="nav-right" style="color: #FFF;">
      <span class="nav-item">
        <button class="button is-primary" type="button" slot="trigger" @click="ssologin">
          <b-icon icon="login"></b-icon>
          <span>ログイン</span>
        </button>
      </span>
    </div>
  </header>
    <div style="height: 200px;" />
    <div class="modal-card" style="width: 600px;">
      <div class="modal-card-head" style="border: 0px solid #dbdbdb; padding-top: 0px; padding-bottom: 0px;">
        <img src="../assets/logo.png" width="94px;" height="auto;"/>
        <p
          class="modal-card-title has-text-centered"
          style="color: whitesmoke"
        >スケジュール管理システム Philips SMS</p>
      </div>
      <div class="modal-card-foot" style="border: 0px solid #dbdbdb;">
        <div
          class="is-inverted"
          style="color:white;width:100%;"
        >Ver.{{version}}</div>
      </div>
    </div>
    <div style="height: 100px;" />
  </div>
</template>

<script>
export default {
  name: "AppSSOLogin",
  data() {
    var version = this.$store.state.version;
    var validFlag = true;
    var accessType = "ブラウザ"
    if (
      navigator.platform == "iPad" || // -iOS12
      (navigator.platform == "MacIntel" && // iPadOS
        navigator.userAgent.indexOf("Safari") != -1 &&
        navigator.userAgent.indexOf("Chrome") == -1 &&
        navigator.standalone !== undefined) ||
      navigator.userAgent == "AppGuardian"
    ) {
      // さらにWebKit判定を仕込む(UserAgentがAppGuardian)
      if (navigator.userAgent.endsWith("AppGuardian")) {
        // WkWebViewのためiPadアプリ
        accessType = "iPad"
      // } else {
      //   alert(
      //     "使用可能な環境ではありません。PCブラウザまたはiPadアプリを使用してください。"
      //   );
      //   validFlag = false;
      }
    }
    if (validFlag) {
      sessionStorage.removeItem('anpyToken')
      sessionStorage.removeItem("guardianToken");
      var guardianToken = this.$route.query.token;
      if (guardianToken) {
        this.$store
          .dispatch("loginWithToken", {
            token: guardianToken
          })
          .then(() => {
            sessionStorage.setItem("guardianToken", guardianToken);
            this.$store.dispatch("getBranchMaster", {});
            this.$store.dispatch("getOfficeMaster", {});
            this.$store.dispatch("getPositionMaster", {});
            this.$store.dispatch("getInspectionHardwareMaster", {});
            this.$router.push({ path: "/main/Welcome" });
          })
          .catch(error => sessionStorage.removeItem("guardianToken"));
      }
    }
    return {
      userId: "",
      password: "",
      email: '',
      otp: "",
      isActive: true,
      accessType,
      version
    };
  },
  methods: {
    ssologin: function(event) {
      console.log("ssologin called.");
      const isSSOLogin = this.$store.state.isSSOLogin;

      if (!isSSOLogin){
        alert(
            "パスワード認証ログイン画面よりログインしてください。"
        );
        return
      }

      this.isActive = false;
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        // iPad
        // さらにWebKit判定を仕込む(UserAgentがAppGuardian)
        if (navigator.userAgent.endsWith("AppGuardian")) {
          // WkWebViewのためiPadアプリ
          this.accessType = "iPad"
        // } else {
        //   alert(
        //     "使用可能な環境ではありません。PCブラウザまたはiPadアプリを使用してください。"
        //   );
        //   return;
        }
      } else {
        this.accessType = "ブラウザ"
      }

      var guardianToken = sessionStorage.getItem("guardianToken");
      if (sessionStorage.getItem("userInfo")) {
        this.$store.dispatch("logout", { token: guardianToken });
      }
      this.$store.dispatch("ssoLogin", {
              mail: this.email,
              password: this.password,
              otptoken: this.otp,
              accessType:this.accessType,
              isSSOLogin:isSSOLogin
            });
    },
  },
  computed: {
    fromApp() {
      var ret = false;
      if (
        navigator.platform == "iPad" || // -iOS12
        (navigator.platform == "MacIntel" && // iPadOS
          navigator.userAgent.indexOf("Safari") != -1 &&
          navigator.userAgent.indexOf("Chrome") == -1 &&
          navigator.standalone !== undefined) ||
        navigator.userAgent == "AppGuardian"
      ) {
        ret = true;
      }
      return ret;
    }
  },
  created() {
    console.log("mounted get mail")
    const query = new URLSearchParams(window.location.search);
    const token = query.get('SSOtoken');
    const isSSOLogin = this.$store.state.isSSOLogin;

    if (isSSOLogin && token){
      this.$store.dispatch("ssoLoginInfo", {otptoken: this.otp,accessType:this.accessType,isSSOLogin:isSSOLogin})
       .then(result => {
         console.log(result);
           this.email = result;
         if (result != 0) {
           throw new Error();
         }
         this.isActive = true;
         this.$store.dispatch("getBranchMaster", {});
         this.$store.dispatch("getOfficeMaster", {});
         this.$store.dispatch("getPositionMaster", {});
         this.$store.dispatch("getInspectionHardwareMaster", {});
         this.$router.push({ path: "/main/Welcome" });
       }).catch(error => {
         this.isActive = true;
       });
    }
  }
};
</script>

<style lang="scss" scoped>
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #061e57;
$primary-invert: findColorInvert($primary);
$info: #209cee;
$info-invert: findColorInvert($info);
$light: whitesmoke;
$light-invert: findColorInvert($light);
$success: #23d160;
$success-invert: findColorInvert($success);
$danger: #ff3860;
$danger-invert: #fff;
$background: #061e57;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  )
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

.login-background-color {
  background: -moz-radial-gradient(#0077cd 20%, #00325d 85%);
  background: -webkit-radial-gradient(#0077cd 20%, #00325d 85%);
  background: radial-gradient(#0077cd 20%, #00325d 85%);
  min-height: 100vh;
  height: auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/AppSSOLogin.vue